import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

/**
 * Get restaurantId from the current URL.
 * Supports both:
 * - query string: ?restaurantId=abc
 * - path params: /menu/:restaurantId (and nested paths)
 */
export function getRestaurantIdFromUrl({ pathname, search } = window.location) {
  try {
    const urlParams = new URLSearchParams(search);
    const fromQuery = urlParams.get('restaurantId');
    if (fromQuery) return fromQuery;
  } catch {
    // ignore
  }

  // Match routes like /menu/<id> or /menu/<id>/...
  const match = String(pathname || '').match(/\/menu\/([^/?#]+)/);
  return match?.[1] || null;
}

/**
 * React hook to access restaurantId for both legacy query-param routes and new /menu/:restaurantId routes.
 */
export function useRestaurantId() {
  const params = useParams();
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    return params.restaurantId || searchParams.get('restaurantId') || getRestaurantIdFromUrl();
  }, [params.restaurantId, searchParams]);
}
